import beianLogo from '../assets/beian-logo.png';

// 备案公示行：ICP（工信部）+ 公安备案（带徽标，公安部查询）
export default function BeianFooter() {
  return (
    <div className="flex items-center justify-center gap-3 flex-wrap text-xs text-gray-400">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer" className="hover:text-gray-600">
        粤ICP备2026116494号-1
      </a>
      <a
        href="https://beian.mps.gov.cn/#/query/webSearch?code=44011402001422"
        target="_blank"
        rel="noreferrer"
        className="hover:text-gray-600 inline-flex items-center gap-1"
      >
        <img src={beianLogo} alt="" className="w-3.5 h-3.5" />
        粤公网安备44011402001422号
      </a>
    </div>
  );
}
